import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Title',
    field: 'contactsTitle',
    filter: 'text',
    searchable: true,
    width: '100px',
  },
  {
    title: 'Customer',
    field: 'customerName',
    filter: 'text',
    searchable: true,
    width: '200px',
  },
  {
    title: 'Office',
    field: 'officeName',
    filter: 'text',
    searchable: true,
    width: '150px',
  },
  {
    title: 'Contact Name',
    field: 'contactsFullName',
    filter: 'text',
    searchable: true,
    navigate: true,
    width: '310px',
  },
  {
    title: 'Contact Type',
    field: 'contactsType',
    filter: 'text',
    searchable: true,
    width: '170px',
  },
  {
    title: 'Description',
    field: 'contactsDescription',
    filter: 'text',
    searchable: true,
    width: '170px',
  },
  {
    title: 'Work Email',
    field: 'contactsWorkEmail',
    filter: 'text',
    searchable: true,
    width: '320',
  },
  {
    title: 'Other Email',
    field: 'contactsSecondaryEmail',
    filter: 'text',
    searchable: true,
    width: '170px',
  },
  {
    title: 'Phone',
    field: 'contactsOfficePhone',
    filter: 'text',
    searchable: true,
    width: '170px',
  },
  {
    title: 'Cell Phone',
    field: 'contactsCellPhone',
    filter: 'text',
    searchable: true,
    width: '170px',
  },
  {
    title: ' Role',
    field: 'contactsRoleName',
    filter: 'text',
    searchable: true,
    width: '170px',
  },
  //changes 07-07-26
  {
    title: 'Contact Source',
    field: 'contactSource',
    filter: 'text',
    searchable: true,
    width: '170px',
  },
  {
    title: 'Send Report',
    field: 'isSendReportEmail',
    filter: 'text',
    searchable: true,
    width: '170px',
  },
  {
    title: ' Fast Field ',
    field: 'sendReport',
    filter: 'text',
    searchable: true,
    width: '170px',
  },
  {
    title: 'Status',
    field: 'contactsStatus',
    filter: 'text',
    searchable: true,
    width: '170px',
  },
];
